(function () {
    'use strict';
    var controllerId = 'societaAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'listini', societaAdd]);

    function societaAdd($scope, datacontext, sectionMenu, $uibModalInstance, listini) {
        $scope.societa = {};
        $scope.societa.LicenzaDemo = 60;
        $scope.societa.InizioAnno = new Date(new Date().getFullYear(), 8, 1);

        $scope.bTitleChanged = false;
        $scope.listini = listini;        

        $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened = !$scope.opened;
        };
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        $scope.format = 'dd/MM/yyyy';

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.societa)
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
        	return datacontext.societa_add(item).then(function (data) {
                if (!data) return null;
                return data;
            });
        }

        $scope.TitleChanged = function () {
        	console.log('TitleChanged');
        	$scope.bTitleChanged = true;
        	return false;
        }

    }
})();